import React, { useState, useEffect } from 'react';
import { PublicLayout } from '../../components/layout/PublicLayout';
import { galleryAPI } from '../../lib/api';
import { Images, X } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

const GalleryPage = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await galleryAPI.getPublic();
        setImages(response.data);
      } catch (error) {
        console.log('Error fetching gallery');
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  return (
    <PublicLayout>
      {/* Header */}
      <section className="py-20 bg-[#1A1614] text-center" data-testid="gallery-header">
        <p className="text-overline mb-4">Visual Archive</p>
        <h1 className="font-heading text-4xl sm:text-5xl text-white mb-4">
          Gallery
        </h1>
        <p className="text-[#8A847A] max-w-2xl mx-auto px-4">
          Images from ceremonies, events, and gatherings of the Grand Priory
        </p>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-[#F5F2EB]" data-testid="gallery-grid">
        <div className="max-w-6xl mx-auto px-4">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="spinner" />
            </div>
          ) : images.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {images.map(image => (
                <button
                  key={image.id}
                  onClick={() => setSelectedImage(image)}
                  className="aspect-square overflow-hidden bg-white border border-[#D8D2C4] hover:border-[#C5A059] transition-colors"
                  data-testid={`gallery-image-${image.id}`}
                >
                  <img
                    src={`${API}/api/gallery/${image.id}/download`}
                    alt={image.title || 'Gallery image'}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </button>
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <Images size={48} className="mx-auto text-[#8A847A] mb-4" />
              <p className="text-[#8A847A]">No images have been added to the gallery yet.</p>
            </div>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          data-testid="gallery-lightbox"
        >
          <button 
            className="absolute top-4 right-4 text-white hover:text-[#C5A059]"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>
          <div className="max-w-4xl max-h-[90vh]" onClick={e => e.stopPropagation()}>
            <img
              src={`${API}/api/gallery/${selectedImage.id}/download`}
              alt={selectedImage.title || 'Gallery image'}
              className="max-w-full max-h-[80vh] object-contain"
            />
            {(selectedImage.title || selectedImage.description) && (
              <div className="text-center mt-4">
                {selectedImage.title && (
                  <h3 className="font-heading text-xl text-white">{selectedImage.title}</h3>
                )}
                {selectedImage.description && (
                  <p className="text-[#8A847A] mt-1">{selectedImage.description}</p>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </PublicLayout>
  );
};

export default GalleryPage;
